import React from 'react'
import { MDXTag } from '@mdx-js/tag'


import DefaultLayout from "/var/lib/jenkins/jobs/app-styleguide/workspace/src/templates/page.js"
import { FormControlColumn, Select, FormGroup } from 'module-tsl-ui-elements';
import WithDocgen from 'module-tsl-ui-elements/with-docs/form-control-column/FormControlColumn';
import pkg from 'module-tsl-ui-elements/package.json';
import PropsTable from '../../../components/propsTable';
import Version from '../../../components/version';
import LiveCode from '../../../components/liveCode';

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = DefaultLayout
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             Layout={this.layout} layoutProps={Object.assign({}, layoutProps, props)}
             components={components}>


<MDXTag name="h3" components={components} props={{"id":"example-editable"}}><MDXTag name="a" components={components} parentName="h3" props={{"href":"#example-editable","aria-label":"example editable permalink","class":"anchor"}}></MDXTag>{`example (editable)`}</MDXTag>
<LiveCode
  code={`<FormControlColumn adjacentChildren>
  <div>
    <div className="form-control-row__col">
      <FormGroup id="form_group" label={{ text: 'Label' }}>
        <Select id="example_child" options={[{ value: 1, label: 'One' }]} />
      </FormGroup>
    </div>
    <div className="form-control-row__col">
      <FormGroup id="form_group" label={{ text: 'Label' }}>
        <Select id="example_child" options={[{ value: 1, label: 'One' }]} />
      </FormGroup>
    </div>
  </div>
</FormControlColumn>`}
  scope={ { FormControlColumn, Select, FormGroup } }
/>
<PropsTable data={WithDocgen.__docgenInfo} />
<Version name={'npm i module-tsl-ui-elements --save'} version={pkg.version} />
           </MDXTag>
  }
}

export const _frontmatter = {};

  